import type { TreeMapNode } from '@graftcode/design-system'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import type { Gateway } from '../../../modules/gateways/types'
import type { Project } from '../../../modules/projects/types'

import { buildGatewayNode } from './tree-builders'
import type { ServiceMapStore } from './types'

function buildTree(project: Project | null, gateways: Gateway[] | null): TreeMapNode[] {
  const _gateways = gateways ?? []
  if (!project) {
    return []
  }
  return _gateways.map((gateway) => buildGatewayNode(gateway))
}

export const useServiceMapStore = create<ServiceMapStore>()(
  devtools(
    immer((set) => ({
      tree: [],

      buildTreeFromData: (project, gateways) =>
        set((state) => {
          state.tree = buildTree(project, gateways)
        }),
    })),
    {
      name: 'ServiceMapStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
